import { AxiosServicesByName } from "./AxiosServices";

export const getDarkWebInfos = async (payload: any) => {
    return await AxiosServicesByName.post("/darkweb", payload);
  };

  export const getAllDarkWebInfos = async (payload: any) => {
    return await AxiosServicesByName.get(`/darkweb/all-infos/${payload}`);
  };